import { render, staticRenderFns } from "./rekrytera-ingenjorer.vue?vue&type=template&id=79b6bd08&scoped=true&"
import script from "./rekrytera-ingenjorer.vue?vue&type=script&lang=ts&"
export * from "./rekrytera-ingenjorer.vue?vue&type=script&lang=ts&"
import style0 from "./rekrytera-ingenjorer.vue?vue&type=style&index=0&id=79b6bd08&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b6bd08",
  null
  
)

/* custom blocks */
import block0 from "./rekrytera-ingenjorer.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCol,VRow})
